import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { Persona } from '../../../models/Persona';
import { ActivatedRoute } from '@angular/router';
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

@Component({
  selector: 'app-nuevo-ref-bancaria',
  templateUrl: './nuevo-ref-bancaria.component.html',
  styleUrls: ['./nuevo-ref-bancaria.component.scss'],
  providers:[Persona,MessagesTitles, MessagesStatus]
})
export class NuevoRefBancariaComponent implements OnInit {
  
  @Input() IdCuenta : string;
  @Output() cerrarAgregarRefBan: EventEmitter<boolean>;

  bancoElement : string;
  monedaElement : number;
  tipoCuentaElement : string;
  mensaje:string;
  mensaje1:string ="";
  Banco: any;
  selected = "0";
  razSocial : string;
  editar:boolean;
  loading:boolean = false;
  isLoading = true;
  save:boolean = false;
  error:boolean = false;
  contactosArray: any;
  user:any;
  bcpAhorro:boolean;
  bcpCorriente:boolean;
  bbvaBanco:boolean;
  banbifBanco:boolean;
  scotiaBanco:boolean;
  banco1:boolean = true;
  formularioRefBancarias : FormGroup;
  idEmpresa : string;
  Titulo:string;
  tipoServicio:any;
  refbancaria:any=[];
  filtroref:any;
  readonly GUIA_DOLARES: number = environment.ID_GUIA_DOLARES;
  constructor(private empresasService : EmpresasService , 
     private routerActive:ActivatedRoute,
     private msgTitulos : MessagesTitles,
     private msgStatus:MessagesStatus) { 

    this.tipoServicio = this.empresasService.tipoServicio 
      
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Nueva Referencia Bancaria";
    this.editar = false;
    this.cerrarAgregarRefBan = new EventEmitter();
      
    this.routerActive.params.subscribe( params => {
      this.idEmpresa = params['id'];
    })

    this.obtenerContactos();  
    this.formularioRefBancarias = new FormGroup({
      "idEmpresa":new FormControl(this.idEmpresa,  Validators.required),
      "Banco": new FormControl('',  Validators.required),
      "Moneda": new FormControl(this.GUIA_DOLARES,  Validators.required),
      "Tipo_de_Cuenta": new FormControl('',  Validators.required),
      "NroCuenta": new FormControl('',  Validators.required),
      "CCI":new FormControl('000000000'),
      "idContacto":new FormControl(''),
      "Estado":new FormControl('A',  Validators.required),
      "Usuario":new FormControl(this.user.Usuario,  Validators.required),
      Tipo_Servicio:new FormControl(this.tipoServicio, []),
      FlgPredeterminado:new FormControl(true, []),
   });
  }

  ngOnInit() {  
  
   this.monedaElement = this.GUIA_DOLARES;
   this.razSocial = sessionStorage.getItem('razSocial');
   this.formularioRefBancarias.controls['idContacto'].setValue(0); 
    if(this.IdCuenta != "" ){
      this.loading = true;
      this.Titulo = "Editar Referencia Bancaria";
      this.editar = true;
      this.empresasService.obtenerReferenciasBancariasEmpresaXID(this.IdCuenta)
      .subscribe(res => {
        this.refbancaria = res;
        this.formularioRefBancarias.controls['Banco'].setValue(this.refbancaria.Banco);
        this.formularioRefBancarias.controls['Moneda'].setValue(this.refbancaria.Moneda);
        this.formularioRefBancarias.controls['NroCuenta'].setValue(this.refbancaria.NroCuenta);
        this.formularioRefBancarias.controls['Tipo_de_Cuenta'].setValue(this.refbancaria.Tipo_de_Cuenta);
        this.formularioRefBancarias.controls['CCI'].setValue(this.refbancaria.CCI);
        this.formularioRefBancarias.controls['idContacto'].setValue(this.refbancaria.idContacto); 

        this.bancoElement = this.refbancaria.Banco;
        this.monedaElement = this.refbancaria.Moneda;
        this.tipoCuentaElement = this.refbancaria.Tipo_de_Cuenta;     

      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Referencia bancaria no obtenida. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
    }
  }

  banco(event){
     this.formularioRefBancarias.controls['Banco'].setValue(event);
   }
  moneda(event){
      this.formularioRefBancarias.controls['Moneda'].setValue(event);
     }  
  tipoCuenta(event){
    this.formularioRefBancarias.controls['Tipo_de_Cuenta'].setValue(event);
    if(this.formularioRefBancarias.controls['Banco'].value == 8  && event == 90 || this.formularioRefBancarias.controls['Banco'].value == 5  && event == 90 ){
      this.mensaje="El número de cuenta debe ser de 14 dígitos.";
      this.mensaje1 = "El CCI debe ser de 20 dígitos como máximo."
      this.bcpAhorro= true;
      this.banco1 = false;
      this.bcpCorriente =false;
      this.bbvaBanco =false;
      this.banbifBanco =false;
      this.scotiaBanco =false;
    }else if(this.formularioRefBancarias.controls['Banco'].value == 8  && event == 91 || this.formularioRefBancarias.controls['Banco'].value == 16  && event == 90 || this.formularioRefBancarias.controls['Banco'].value == 16  && event == 91 ){
      this.mensaje="El número de cuenta debe ser de 13 dígitos.";
      this.mensaje1 = "El CCI debe ser de 20 dígitos como máximo."
      this.bcpCorriente= true;
      this.banco1 = false;
      this.bcpAhorro =false;
      this.bbvaBanco =false;
      this.banbifBanco =false;
      this.scotiaBanco =false;
    }else if(this.formularioRefBancarias.controls['Banco'].value == 7  && event == 91 || this.formularioRefBancarias.controls['Banco'].value == 7  && event == 90){
      this.mensaje="El número de cuenta debe ser de 18 dígitos."
      this.mensaje1 = "El CCI debe ser de 20 dígitos como máximo."
      this.bbvaBanco= true;
      this.banco1 = false;
      this.bcpAhorro =false;
      this.bcpCorriente =false;
      this.banbifBanco =false;
      this.scotiaBanco =false;
    }else if(this.formularioRefBancarias.controls['Banco'].value == 6  && event == 91 || this.formularioRefBancarias.controls['Banco'].value == 6  && event == 90){
      this.mensaje="El número de cuenta debe ser de 20 dígitos."
      this.mensaje1 = "El CCI debe ser de 20 dígitos como máximo."
      this.banbifBanco= true;
      this.banco1 = false;
      this.bcpAhorro =false;
      this.bcpCorriente =false;
      this.bbvaBanco =false;
      this.scotiaBanco =false;
    }else if(this.formularioRefBancarias.controls['Banco'].value == 20 && event == 91 || this.formularioRefBancarias.controls['Banco'].value == 20  && event == 90){
      this.mensaje="El número de cuenta debe ser de 10 dígitos."
      this.mensaje1 = "El CCI debe ser de 20 dígitos como máximo."
      this.scotiaBanco= true;
      this.banco1 = false;
      this.bcpAhorro =false;
      this.bcpCorriente =false;
      this.bbvaBanco =false;
      this.banbifBanco =false;
    }else{
      this.banco1 = true;
    }
   }     

  

  obtenerContactos(){
    this.empresasService.obtenerContactosEmpresa(this.idEmpresa).subscribe( 
      resp => {
        this.contactosArray = resp;
        console.log('array',this.contactosArray)
        this.contactosArray = this.contactosArray.filter(
          state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === 56
        );
        this.contactosArray.push({'idContacto':0,'Des_Estado':"ACTIVO",'Nombre_de_Contacto':"NO APLICA",'Rol_Del_Contacto_Dsc':"REPRESENTANTE LEGAL"});
        this.loading = false;
      },err => {
        console.error("Error Event");
      }
    );      
  }
  
  crearCuentaBancaria(){
    let NroCuenta = this.formularioRefBancarias.controls['NroCuenta'].value;
    let resNroCuenta = NroCuenta.replace(/-/gi,"")
    let NroCCI = this.formularioRefBancarias.controls['CCI'].value;
    let resNroCCI = NroCCI.replace(/-/gi,"")
    let resNroCuentaS = resNroCuenta.replace(/\s+/gi,"");
    let resNroCCIS = resNroCCI.replace(/\s+/gi,"");
    let resNroCuentaAbc = resNroCuentaS.replace(/[A-Z]/gi,"")
    let resNroCCISAbc = resNroCCIS.replace(/[A-Z]/gi,"")
    if(this.formularioRefBancarias.invalid){
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Complete los campos requeridos ",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }
    if (this.formularioRefBancarias.controls['FlgPredeterminado'].value == true ){
      this.formularioRefBancarias.controls['FlgPredeterminado'].setValue(1)
    }else{
      this.formularioRefBancarias.controls['FlgPredeterminado'].setValue(0)
    }
    this.loading = true;
    this.error = false;

    if(this.editar){
      this.empresasService.editarReferenciaBancaria(this.formularioRefBancarias.getRawValue(),this.IdCuenta)
      .subscribe(res => {
          
        this.loading = false;
        this.save = true;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Referencia bancaria no actualizada. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
            
    }else{
      this.formularioRefBancarias.controls['NroCuenta'].setValue(resNroCuentaAbc)
      this.formularioRefBancarias.controls['CCI'].setValue(resNroCCISAbc)
      console.log('ref',this.formularioRefBancarias.getRawValue())
      this.empresasService.agregarReferenciaBancaria(this.formularioRefBancarias.getRawValue())
      .subscribe(res => {
        
        this.loading = false;
        this.save = true;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Referencia bancaria no registrada. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })      

    }

  }
  
  CerrarPopUp(){
    this.cerrarAgregarRefBan.emit();
  }

  ConsultarCCI(){

    this.Banco = this.formularioRefBancarias.getRawValue().Banco;
    switch(this.Banco){
      case 5 :
      case 9 :
      case 19 :    
        Swal.fire(
          '¡Atencion!',
          'El banco seleccionado no cuenta con CCI.',
          'warning'
        )
        break;
      case 6 :
        window.open("https://bancaporinternet.banbif.com.pe/DVAIBS_BIFNET/servlet/com.bif.dva.modules.consulta.servlet.JSConsulta?PB=1&LNG=s/&TP_INGRESO=2&preserve=N","_blank")
        break;
      case 7 :
        window.open("https://extranetperu.grupobbva.pe/portalperu/paginas/convertidorCCI.jsp","_blank")
        break;
      case 8 :
        window.open("https://ww3.viabcp.com/connect/pdf/servicios_empresas/conversor/conozca.html","_blank")
        break;
      case 10 :
        window.open("http://citibank.com.pe/peru/common/components/cci/main.htm","_blank")
        break;
      case 11 :
        window.open("https://www.cajapiura.pe/servicios/transferencias-interbancarias/consulta-tu-codigo-cci/","_blank")
        break;
      case 12 :
        window.open("https://enlinea.bancomercio.com/Webquery/querycci.jsp","_blank")
        break;
      case 13 :
        window.open("https://www.bancofalabella.pe/cci/conoce-codigo-interbancario.html","_blank")
        break;
      case 14 :
        window.open("https://ib.bancognb.com.pe/client/cci/","_blank")
        break;
      case 15 :
        window.open("http://www.icbc.com.pe/ICBC/%E6%B5%B7%E5%A4%96%E5%88%86%E8%A1%8C/%E5%B7%A5%E9%93%B6%E7%A7%98%E9%B2%81%E7%BD%91%E7%AB%99/es/consultadecci.htm","_blank")
        break;
      case 16 :
        window.open("https://interbank.pe/cci","_blank")
        break;
      case 17 :
        window.open("https://www.mibanco.com.pe/noticia/conoce-tu-cci","_blank")
        break;
      case 18 :
        window.open("http://aplicacionespichincha.com.pe/BFP.CCI.WEB/Consulta_Ext_CCI.aspx","_blank")
        break;
      case 20 :
        window.open("https://scotiaenlinea.scotiabank.com.pe/bancaInternetEmp/InicioCCIServlet","_blank")
        break;
      case '':
        Swal.fire(
          '¡Atencion!',
          'Debe seleccionar un banco',
          'warning'
        )
        break;
    }
  }

}